import { SnAlarm } from '@lib/api/entities';
import { FsAdvancedMarker } from '@lib/geo/google/map';

import { AlarmMarkerIconInterface } from './alarm-marker-icon';

export class FsAlarmAdvancedMarker extends FsAdvancedMarker {
  constructor(public alarm?: SnAlarm, public cluster?: any) {
    super(
      {
        position: cluster
          ? new google.maps.LatLng(cluster.geometry.coordinates[1], cluster.geometry.coordinates[0])
          : new google.maps.LatLng(alarm.geometry.coordinates[1], alarm.geometry.coordinates[0]),
        title: alarm ? alarm.id : null,
        content: document.createElement('div'),
      },
      null,
      cluster,
    );
    const content: any = this.getMarker().content;
    const markerType = cluster ? 'fs__advanced-alarms-cluster' : 'fs__alarms-advanced-marker';
    const icon = cluster ? 'Icon_GeneralAlert' : this._getIcon().fontIcon;
    content.classList.add(markerType);
    content.innerHTML = `
      <img class="fs__alarms-advanced-icon" src="/assets/fusus-icons/PNG/${icon}.png"/>
    `;
    if (this.cluster) {
      this.createBadge();
    }
    content.classList.add('fs__center-marker');
  }

  get icon(): AlarmMarkerIconInterface {
    return this._getIcon();
  }

  private _getIcon(): AlarmMarkerIconInterface {
    const icon: AlarmMarkerIconInterface = {
      fontIcon: 'Icon_GeneralAlert',
      fontSet: 'fs',
    };

    switch (this.alarm.type.toLowerCase()) {
      case 'soundthinking':
        icon.fontIcon = 'Icon_ShotSpotter';
        return icon;
      case 'soundthinkingtracer':
        icon.fontIcon = 'Icon_ShotSpotter';
        return icon;
      case 'shooter detection systems':
        icon.fontIcon = 'Icon_ShotSpotter';
        return icon;
      case 'panic app':
        icon.fontIcon = 'Icon_Panic';
        return icon;
      case 'rt alpr':
        icon.fontIcon = 'Icon_LPAR';
        return icon;
      case 'vigilant learn alpr':
        icon.fontIcon = 'Icon_Vigilant';
        return icon;
      case 'fs alpr':
        icon.fontIcon = 'Icon_FS';
        return icon;
      case 'genetec alpr':
        icon.fontIcon = 'Icon_Genetec';
        return icon;
      case 'rekor alpr':
        icon.fontIcon = 'Icon_Rekor';
        return icon;
      case 'dronesense':
        icon.fontIcon = 'Icon_DroneSense';
        return icon;
    }

    return icon;
  }
}
